import { render, staticRenderFns } from "./InitialForm.vue?vue&type=template&id=4ed71a3a&scoped=true"
import script from "./InitialForm.ts?vue&type=script&lang=ts&external"
export * from "./InitialForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed71a3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ed71a3a')) {
      api.createRecord('4ed71a3a', component.options)
    } else {
      api.reload('4ed71a3a', component.options)
    }
    module.hot.accept("./InitialForm.vue?vue&type=template&id=4ed71a3a&scoped=true", function () {
      api.rerender('4ed71a3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P38/InitialForm/InitialForm.vue"
export default component.exports